export default {
  individual: {
    header: 'Individual & Family Health Insurance',
    body: `<div class="title-sm">Smart Decisions Today for a Healthy Tomorrow</div>
<p>As an individual, you’re most likely responsible not only for yourself, but also for the well being of your family.
In order to keep yourself and those you care about most healthy and happy, you’ll want to ensure that you have the proper
Health Insurance plan that can cover your every need and keep you protected financially.</p>
<p>With the cost of healthcare on the rise, you can’t afford to take any chances.
At SIG & Associates, we offer Individual and Family Health Insurance plans to those who do not
receive health benefit packages from their current employer, or are either self-employed, unemployed, or a student.
Our various types of Individual and Family Health Insurance options include:</p>

<ul>
<li>FFS (Fee-for-Service)</li>
<li>HMO (Health Maintenance Organization)</li>
<li>PPO (Preferred Provider Organization)</li>
<li>POS (Point-of-Service)</li>
<li>HSA (Health Savings Account)</li>
</ul>

<p>Since each insurance option differs in cost and benefits, it’s important to discuss your unique needs with an
insurance professional who can keep you, your spouse, and your children covered under the right plan at a price you can afford.</p>

<div class="title-sm">Find a Health Insurance Plan That’s Right For You</div>

<p>Without an adequate Health Insurance policy, if you or a family member gets injured in an accident or becomes ill,
the last thing you’ll want to experience is paying for high medical costs from your own pocket.</p>
<p>If you’re an individual looking for coverage either for yourself or your family,
you can find the perfect Individual and Family Health Insurance plan from SIG & Associates.
Since Health Insurance options vary from state to state, our experienced, Health Insurance specialists are available
to work with your needs on an individual basis in order to assist you in creating a plan that keeps you covered.</p>
<p>Don’t risk your finances on expensive medical bills and services. Get the affordable protection that
keeps those you care about most healthy with an Individual and Family Health Insurance policy.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  group: {
    header: 'Group Health Insurance',
    body: `<div class="title-sm">Benefits that Keep your Employees Happy</div>
<p>As an employer in today’s business world, SIG & Associates knows how important it is to provide health insurance
to the most valuable asset of your business – your employees. By providing each employee with a plan that meets his
or her expectations, it can help your business lower turnover and keep a staff that’s healthy and insured with peace of mind.</p>
<p>At SIG & Associates, we’re proud to offer a variety of group health Insurance plans for small to mid-sized businesses
– for quality assurance and additional benefits. Our health insurance specialists will work with you one-on-one to develop
a group plan that’s not only affordable, but complements your business’s needs..</p>

<div class="title-sm">Which Plan is Right for your Business?</div>
<p>Group health insurance plans typically include either indemnity plans, such as Fee-for-Service (FFS),
or managed care plans, including: Health Maintenance Organization (HMO),
Preferred Provider Organization (PPO), and Point-of Service (POS).</p>
<p>The major difference between Indemnity and managed care plans is the types of providers,
choices of doctors and physicians, out of pocket expenses, and medical bill payments.</p>
<p>Since group health insurance options vary from state to state in coverage options and benefits,
as well as the size of your business, it’s important to discuss your business’s Health Insurance needs
with a specialist at SIG & Associates who can help you find a solution that’s ideal and feasible for you and your employees.</p>

<p><small><i>SIG & Associates provides group health insurance to businesses in Wichita Falls,
Haslet, Decatur, Prosper, Vernon, Garland, and surrounding areas.</i></small></p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  dental: {
    header: 'Dental Coverage',
    body: `<div class="title-sm">Benefits That Can Make You Smile.</div>
<p>With Dental Coverage as one of the most desirable options for most Americans, finding the proper plan is critical.</p>
<p>Whether you’re an employer looking to provide Dental Coverage to your employees and their families under a group plan,
or are an individual looking to add dental as a supplement to your Individual and Family Health Insurance plan,
SIG & Associates has a solution that’s right for you. From routine cleanings and check ups to additional dental work,
it’s important to utilize this coverage in order to maintain good oral hygiene and overall health.</p>
<p>Our Dental Coverage options include:</p>

<ul>
<li>Traditional Indemnity</li>
<li>Dental Health Maintenance Organization (DHMO)</li>
<li>Preferred Provider Organization (PPO)</li>
</ul>

<p>While there are several types of Dental Coverage options, it’s important to discuss what’s right for you with a
representative from SIG & Associates. We’ll help you find a plan that meets your requirements in terms of feasible co-pays,
a quality dental network, overall plan price, and much more.</p>
<p>Contact SIG & Associates today to receive Dental benefits that keep you, your family, and those around you happy.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  vision: {
    header: 'Vision Coverage',
    body: `<div class="title-sm">Additional Benefits Matter</div>
<p>If you’re like many Americans, you require either glasses or contact lenses to get you through the day.
And whether you’re an employer searching to provide Vision Coverage to your employees, or an individual looking to
add vision as a supplement to your Individual and Family Health Insurance Plan,
finding a good plan at the right price is critical.</p>
<p>At SIG & Associates, we can help you develop a Vision Plan that keeps employees and family members covered from
paying large out-of-pocket expenses associated with common optical needs. To learn more, please contact a
representative at SIG & Associates today to find out how Vision Coverage
can benefit you, your family, and your employees.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  'long-term': {
    header: 'Long-Term Care Insurance',
    body: `<div class="title-sm">Personal and Financial Protection for the Long Term.</div>
<p>For most Americans, a traditional Life and Health Insurance package is enough to keep themselves and
their families insured, but for many, additional coverage is required. At SIG & Associates,
we offer extensive coverage options that can insure the care of those who need it most.</p>
<p>Long-Term Care Insurance (LTC) helps provide for the medical expenses of extended home
health care or nursing home costs beyond a specified period. In general, individuals who require
Long-Term Care are those who can no longer take care of themselves and are unable to
perform the basic activities of daily living without assistance.</p>
<p>The costs of Long-Term Care can be quite expensive, and are typically not covered under basic
Health Insurance, Medicare, or Medicaid. Long-Term Care Insurance from SIG & Associates can
protect your family’s financial future by providing valuable coverage benefits for costs associated with:</p>

<ul>
<li>Home Care</li>
<li>Assisted Living</li>
<li>Adult Daycare</li>
<li>Hospice Care</li>
<li>Nursing Homes</li>
<li>Respite Care</li>
</ul>

<p>Individuals looking to purchase Long-Term Care Insurance
must meet certain conditions in order to qualify for benefits. Talk to an insurance professional with
SIG & Associates to learn more about Long-Term Care Insurance and whether you should add it to your current policy.</p>

<p><small><i>All guarantees and benefits of the insurance policy are backed by the claims-paying ability of the issuing
insurance company. Policy guarantees and benefits are not backed by the broker/dealer and/or insurance agency
selling the policy, nor by any of their affiliates, and none of them makes any representations or guarantees
regarding the claims-paying ability of the issuing insurance company.</i></small></p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  temp: {
    header: 'Temporary Health Insurance',
    body: `<div class="title-sm">Protection that Matters in the Short Run</div>
<p>At SIG & Associates, we realize that individual people require individual insurance needs based
on their current situation. And as an insurance agency, we also know that an unexpected accident
or illness can happen at any time. That’s why we want to help you with all of your
short-term needs in the event that you require a temporary solution.</p>
<p>A Temporary, or Short-Term, Health Insurance plan from SIG & Associates can
be purchased for a variety of reasons. It’s a way to keep you protected from accidents
or illnesses that occur when you are not insured under a standard Health Insurance policy.
Individuals who require Short-Term coverage are typically those who:</p>

<ul>
<li>Have a gap in their Health Insurance as a result of switching jobs</li>
<li>Are waiting to receive benefits from their current employer</li>
<li>Have recently graduated and are looking for employment</li>
<li>Maintain a seasonal or temporary position</li>
</ul>

<div class="title-sm">What’s Covered Under a Temporary Health Plan?</div>
<p>The right Temporary Health Insurance plan can assist in covering hospital visits,
prescription drug costs, and other situations that require medical attention for injury or illness.
There are several limitations; however, that are not included. These items include: physicals, exams,
and pre-existing conditions. Since the terms, conditions, and duration of your policy may vary,
it’s important to talk to an insurance specialist at SIG & Associates who can
help you find a plan that meets your needs.</p>
<p>Don’t experience the financial burden of out-of-pocket medical expenses as
a result of an unexpected injury or illness between your Health Insurance plans.
Get the coverage you deserve today with a flexible and affordable
Temporary Health Insurance plan from SIG & Associates.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  supp: {
    header: 'Supplemental Insurance',
    body: `<div class="title-sm">Additional Insurance to Cover the Gaps.</div>
<p>At SIG & Associates, we’re committed to offering a total array of insurance services that meet
your every need. That’s why we offer additional insurance coverage to keep you
protected in areas that your current Health Insurance policy does not cover –
for peace of mind assurance that keeps your finances secure.</p>
<p>Supplemental Insurance works to cover any gaps in your Health Insurance plan.
This can include any out-of-pocket medical expenses, such as deductibles and co-payments
that you cannot afford. It can also provide cash benefits to assist you in certain
situations such as, high living expenses, loss of income due to an illness or injury,
and money to pay for medication.</p>

<div class="title-sm">Types of Supplemental Insurance</div>
<p>There are many types of Supplemental Insurance, which is why it’s important to
talk with an insurance representative from SIG & Associates to discuss your options.
A couple of examples include additional insurance for Medicare and Maternity.</p>
<p><b>Medicare Supplemental Insurance</b> provides current individuals under Medicare
with assistance for items not covered under Medicare Part A and Part B. This can include co-pays,
deductibles, and co-insurance that can add up to large out-of-pocket expenses.</p>
<p><b>Maternity Supplemental Insurance</b> helps to cover any medical expenses up to the delivery of the baby.
This can include deductibles, co-payments, and more – so you’re not stuck with
unexpected expenses on top of your existing bills.</p>
<p>Since Supplemental Insurance is an addition to your Health Insurance policy,
it’s important to note that it does not act as a traditional Health Insurance policy.</p>
<p>Avoid gaps in your current Health plan with Supplemental Insurance from SIG & Associates.</p>
`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  disability: {
    header: 'Disability Insurance',
    body: `<div class="title-sm">Your Biggest Asset is You</div>
<p>When it comes to protecting your assets, one of the most important things
you can insure isn’t a material object like your car or home – it’s your ability to
work and earn a living. At SIG & Associates, we know that like most people,
you depend on your income to pay bills, put food on the table, and provide for your family.
But if you get sick or injured and can’t work, you’ll need to be protected in
order to maintain your standard of living.</p>

<p>With disability income Insurance from SIG & Associates, you can continue to pay your
bills and keep you and your family from going into serious debt. If you can’t work as a
result of injury or other illness, a disability insurance policy will
pay a portion of your income, usually between 50 and 70 percent.</p>

<p>Policies can vary greatly depending on the individual,
and the duration and amount for which you are reimbursed are determined by the nature of the
disabling accident. Like life insurance, disability is purchased for a period of time, such
as a two or five-year term, and benefits will only be paid if you become disabled during the term of the policy.</p>

<p>Choosing the right disability coverage is important. In the event you become disabled,
you'll want to ensure that you and your family have enough coverage.
A representative at SIG & Associates will look at the individual factors in your life and work situation,
and help design the best policy that meets your personal insurance needs.</p>

<p><small><i>SIG & Associates provides disability insurance to individuals in Wichita Falls,
Haslet, Decatur, Prosper, Vernon, Garland, and surrounding areas.</i></small></p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  expense: {
    header: 'Medical Expense Insurance',
    body: `<div class="title-sm">Keep Your Medical Service Needs Covered</div>

<p>In the event that you or any of your loved ones get injured or become ill,
you’ll need a policy that prevents you from paying high out-of-pocket expenses for
medical services. With the right coverage, you can achieve
peace of mind knowing that you’re appropriately protected.</p>

<p>At SIG & Associates, we can offer Medical Expense Insurance to prevent you from feeling the burden
of high-priced medical costs. We know that after a hospital visit or a procedure,
the last thing you’ll want to experience is paying bills that you cannot afford.</p>

<div class="title-sm">Types of Medical Expense Insurance</div>
<p>There are typically two types of policies: Basic Medical and Major Medical Expense.</p>

<p><b>Basic Medical Expense</b> policies offer coverage for standard hospital, surgical, and physician expenses.
It works to insure certain types of hospital visits/stays,
surgery for specific types of procedures, and common physician fees.</p>

<p><b>Major Medical Expense</b> policies are for covering expenses that take over
when the limits of a basic insurance plan have been exhausted.
This typically involves more catastrophic situations over basic injury or illness.</p>

<p>To find out more, please contact SIG & Associates today.
One of our helpful Health Insurance specialists will work with you to create a
Medical Expense policy that fits the needs of you and your family.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  child: {
    header: 'Child Health Insurance',
    body: `<div class="title-sm">Insurance Solutions for Those in Need</div>

<p>Unfortunately, not everyone can afford a Health Insurance policy.
At SIG & Associates, we believe that each person deserves some sort of coverage in the event of illness or injury.</p>

<p>Depending on your location and situation, there may be several options for
keeping your children insured so they can receive the care they need, when they need
it most for physician visits, dental and vision services, prescription coverage, and more.
Options like Medicaid for low-income children and adults, or a State
Children’s Health Insurance Program may be the right solution.</p>

<p>Contact a specialist at SIG & Associates to learn more today.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  travel: {
    header: 'Travel Health Insurance',
    body: `<div class="title-sm">Coverage that Travels with You</div>

<p>Traveling is a great way to either spend time with your loved ones, or take some time
off from your busy schedule and simply relax. At SIG & Associates, we want to wish you safe
travels on your next adventure and keep you safe with protection that matters.</p>

<p>An accident can happen at any time – even on vacation. And whether you’re oversees
or across the country, the best way to ensure that you’re protected at all times is
with a Travel Health Insurance plan that’s right for you. The last thing you’ll
want to experience is being sick or injured in an unfamiliar place.</p>

<p>SIG & Associates offers additional Travel Health Insurance policies that keep you
covered in the event of travel-related accidents or conditions, such as:</p>

<ul>
<li>Car Accidents (whether you’re the driver, a passenger, or pedestrian)</li>
<li>Accidental Injury or Disability</li>
<li>Loss of Eyesight or Hearing</li>
<li>Sickness</li>
<li>Medical Evacuation</li>
<li>Accidental Death</li>
</ul>

<p>While there are other options available, including insurance for any
lost items or delays, it’s important to discuss your travel needs for your
next trip with a professional at SIG & Associates. This type of coverage typically
lasts throughout the duration of your trip outside of the country and generally expires upon your return.</p>

<p>Enjoy your next trip with the peace of mind assurance that you
and your loved ones are protected with flexible and affordable Travel Health Insurance.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  prescription: {
    header: 'Prescription Insurance',
    body: `<div class="title-sm">Extra Discounts for Your Medication</div>

<p>SIG & Associates understands the importance of your daily medication. And with today’s
increasing costs of prescription drugs, you may find it difficult to pay for the expenses
from your own pocket – especially if you depend on taking various medications for multiple symptoms.</p>

<p>With the right Prescription Insurance, you can remove much of the
financial burden and make your medication more affordable. A typical plan can:</p>

<ul>
<li>Reduce the cost of your medications</li>
<li>Decrease your co-pay expenses</li>
<li>Cover any specialized medications</li>
<li>Make your out-of-pocket expenses feasible</li>
</ul>

<p>Since there are many coverage types and Prescription Insurance plans available,
it’s important to discuss your options with a specialist from SIG & Associates to see
if your current Health plan requires extra coverage for your individual needs.</p>

<p>Contact SIG & Associates today to find out how additional Prescription Insurance can save you money.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  }
}



// WEBPACK FOOTER //
// ./src/helpers/healthHelper.js